import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '@/hooks/use-online-status'

/** Bandeau collant affiché dès que le navigateur se déclare hors connexion. */
export function OfflineBanner() {
  const online = useOnlineStatus()

  if (online) return null

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex items-center justify-center gap-2 border-b border-danger-border bg-danger-bg px-4 py-2 pt-safe text-[13px] font-medium text-danger"
    >
      <WifiOff size={15} aria-hidden="true" />
      Hors connexion — les données ne sont pas à jour
    </div>
  )
}
